import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NotificationService } from "src/app/core/services/notification.service";
import { setStartTime } from "src/app/shared/utils/utils";
import { OrdersService } from "../../feature/orders/services/orders.service";
import { OrderJobSetBack, OrderSetBack } from "../../interfaces/setback.interface";

@Component({
	selector: "app-setback-dialog",
	templateUrl: "./setback-dialog.component.html"
})
export class SetbackDialogComponent implements OnInit, OnDestroy {

	loading: boolean;
	setbackForm: UntypedFormGroup;
	private unsubscribe$: Subject<void>;

	constructor(
		public fb: UntypedFormBuilder,
		private dialogRef: MatDialogRef<SetbackDialogComponent>,
		private orderService: OrdersService,
		private notificationService: NotificationService,
		@Inject(MAT_DIALOG_DATA) public data: {
			id: string;
			name: string;
			jobList: Array<OrderJobSetBack>;
		}
	) {
		this.unsubscribe$ = new Subject<void>();
	}

	ngOnInit(): void {
		this.createForm();
	}

	private createForm(): void {
		this.setbackForm = this.fb.group({
			startDate: ['', Validators.required],
			startTime: ['', Validators.required],
			comments: ['', Validators.required],
			laborOrderJobs: new UntypedFormArray(
				this.data.jobList?.map((j) => {
					return new UntypedFormGroup({
						id: new UntypedFormControl(j.id),
						name: new UntypedFormControl(j.name),
						startDate: new UntypedFormControl(),
						startTime: new UntypedFormControl('', [Validators.required])
					})
				})
			)
		});
		this.subscribeStartTime();
	}

	private subscribeStartTime(): void {
		this.setbackForm.get("startTime").valueChanges.pipe(
			takeUntil(this.unsubscribe$)
		).subscribe((value) => {
			if (value) {
				(<UntypedFormArray>this.setbackForm.get("laborOrderJobs")).controls.forEach((c) => {
					if (c.get('startTime').value?.length !== 4) {
						c.get('startTime').setValue(value);
					}
				});
			}
		});
	}

	confirm(): void {
		this.loading = true;
		let payload: OrderSetBack = this.setbackForm.value;
		payload = setStartTime(payload);
		payload.laborOrderJobs.forEach((j) => {
			if (j.startTime) {
				if (j.startTime !== payload.startTime) {
					const startDate: Date = new Date(payload.startDate);
					const hours: number = parseInt(j.startTime.substring(0, 2)) || 0;
					const minutes: number = parseInt(j.startTime.substring(2, 4)) || 0;
					startDate.setHours(hours);
					startDate.setMinutes(minutes);
					let userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
					j.startDate = new Date(startDate.getTime() - userTimezoneOffset);
				} else {
					j.startDate = payload.startDate;
				}
			} else {
				j.startDate = null;
			}
		});

		this.orderService.setBack(this.data.id, payload).toPromise().then(
			(response) => {
				this.notificationService.showSuccess("Order was setback succesfully.");
				this.dialogRef.close(response);
			},
			(error) => {
				this.notificationService.showError("There was a problem setback order. Please try again.");
				this.loading = false;
			}
		)
	}

	close(): void {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

}
